<template>
  <div class='pages classroom-task-page'>
    <el-card>
        <el-form >
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="学生姓名">
                        <el-input v-model="querySerach.studentName" placeholder="请输入学生姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="getSearch">查询</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-table
            :data="pages.list"
            style="width: 100%; margin-bottom: 20px"
            row-key="list"
            :tree-props="{ children: 'list' }"
            border
            :loading="pages.loading"
        >
            <el-table-column prop="studentName" label="学生姓名" />
            <el-table-column prop="gradeName" label="年级" />
            <el-table-column prop="date" label="日期" />
            <el-table-column prop="subjectValue" label="科目" />
            <el-table-column prop="teacherName" label="教师" />
            <el-table-column prop="classFeedback" label="课堂反馈">
                <template v-slot="{ row }">
                    <div v-if="row.classFeedback">
                        <div v-if="row.classFeedback.teacherFeedbackContent">
                            <h3>反馈内容：</h3>
                            {{ row.classFeedback.teacherFeedbackContent }}
                        </div>
                        <div v-if="row.classFeedback.teacherFeedbackPicture">
                            <h3>反馈图片：</h3>
                            <el-image 
                                v-for="img in row.classFeedback.teacherFeedbackPicture.split(',')"
                                :preview-teleported="true"
                                :src="img" 
                                style="width: 200px; height: 200px"
                                :preview-src-list="[img]"
                                :zoom-rate="1.2"
                                :max-scale="7" 
                                :min-scale="0.2" 
                                alt="" 
                            />
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="jobFeedback" label="课后作业">
                <template v-slot="{ row }">
                    <div v-if="row.jobFeedback">
                        <div v-if="row.jobFeedback.jobContent">
                            <h3>课堂内容：</h3>
                            {{ row.jobFeedback.jobContent }}
                        </div>
                        <div v-if="row.jobFeedback.jobPicture">
                            <h3>课堂图片：</h3>
                            <el-image 
                                v-for="img in row.jobFeedback.jobPicture.split(',')"
                                :preview-teleported="true"
                                :src="img" 
                                style="width: 200px; height: 200px"
                                :preview-src-list="[img]"
                                :zoom-rate="1.2"
                                :max-scale="7" 
                                :min-scale="0.2" 
                                alt="" 
                            />
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <pagination
            :page="pages.page"
            :pagesize="pages.pagesize"
            :total="pages.total"
            @on-page-change="handleChange"
        ></pagination>

    </el-card>
  </div>
</template>
<script setup>
    import { reactive } from 'vue'
    import { usePageList } from '@/hooks/use-page-list'
    import pagination from '@/components/Pagination'
    import { Search, Refresh } from '@element-plus/icons-vue'

    const querySerach = reactive({
        studentName: ''
    })

    const pages = reactive({
        page: 1,
        pagesize: 10,
        total: 0,
        loading: false,
        list: []
    })
    const { fetchGetList } = usePageList('app/classFeedback/list')

    const getList = async () => {
        const { page, pagesize } = pages
        const { studentName } = querySerach
        pages.loading = true
        try {
            pages.list = []
            const res = await fetchGetList({
                page,
                pagesize,
                studentName
            })
            pages.total = Number(res.total)
            pages.list = res.rows || []
        } catch (error) {
            // ElMessage.error('下载文件出现错误，请联系管理员！');
        } finally {
            pages.loading = true
        }
    }

    getList()

    const getSearch = () => {
        pages.page = 1
        pages.pagesize = 10
        getList()
    }

    const handleChange = (e) => {
        pages.page = e.page
        pages.pagesize = e.pagesize
        getList()
    }


</script>


<style scoped lang='less'>

</style>